import { Component, OnInit, AfterViewInit } from '@angular/core';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { CookieCiencuadras } from '../../utils/cookie-ciencuadras/cookie-ciencuadras';
import { AppState } from '../../app.reducer';
import { ShoppingDialogComponent } from '../shopping-dialog/shopping-dialog.component';
import { CcLoginComponent, CcRegisterComponent, PasswordRecoverComponent } from 'cc-components-lib';
import { environment } from '@env/environment';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, AfterViewInit {
  panelOpenState = false;
  btnMenu: any;
  scroll: any;
  backdrop: any;
  
  count: number = 0;
  countPlan: number = 0;
  countProducts:number = 0;

  userPrivateZone: boolean = false;
  public ccEnvironment: any;

  constructor(
    private store: Store<AppState>,
    private dialog: MatDialog,
    private dialogLogin: MatDialog,
    private cookieCiencuadras: CookieCiencuadras
  ) { 
    this.ccEnvironment = environment;
  }

  ngAfterViewInit(): void {
    /* this.btnMenu = document.getElementById('menu-btn'); */
    this.scroll =  document.querySelector('html');
    this.backdrop =  document.getElementById('backdrop-menu');
  }

  ngOnInit(): void {

    setTimeout(() => {
      this.cookieCiencuadras.setCookie('last_url', window.location.pathname);
    },500);
    
    if(document.location.pathname === '/productos/zona-de-usuario'){
      this.userPrivateZone = true;
    }

    this.store.select('carPlanCheckout').subscribe( plan =>{
      this.countPlan = 0;
      plan.forEach(item => {
        this.countPlan =  plan.length;
      });
      this.count = this.countProducts + this.countPlan;
    });

    this.store.select('carCheckout').subscribe( product =>{
      this.countProducts = 0;
      product.forEach(item => {
        this.countProducts = this.countProducts + item.quantity;
      });
      this.count = this.countProducts + this.countPlan;
    });
  }

  openShoppingDialog = (): void => {
    if (this.count > 0) {
      const shoppingConfig = new MatDialogConfig();
      shoppingConfig.panelClass = 'shopping-modal';
      shoppingConfig.backdropClass = 'shopping-backdrop';
      // shoppingConfig.data = false
      this.dialog.open(ShoppingDialogComponent, shoppingConfig);
    }
  }
  
  OpenOnboardingModal(Onboarding: any){
    console.log("event onboarding -->", Onboarding);

    this.dialog.closeAll();
    if(Onboarding.modal == 1){
      console.log("Onboarding.modal-->", Onboarding.modal);
      this.OpenLoginModal(Onboarding.typeUser);
    }
    if(Onboarding.modal == 2){
      this.OpenRecoverPwModal(Onboarding.typeUser);
    }
    if(Onboarding.modal == 3){
      this.OpenRegisterModal(Onboarding.typeUser);
    }
  }

  OpenLoginModal(typeUser: string){
    let DialogRefLogin = this.dialogLogin.open(CcLoginComponent, {
      data:  {'isModal': true , 'typeUser': typeUser},
      panelClass: 'onboardingModal'
    });
    DialogRefLogin.componentInstance.OpenOnboardingModalEvent.subscribe((res: any) => {
      this.OpenOnboardingModal(res);
    });

  }

  OpenRecoverPwModal(typeUser: string){
    let DialogRefRecover = this.dialogLogin.open(PasswordRecoverComponent , {
      data:  {'isModal': true , 'typeUser': typeUser},
      panelClass: 'onboardingModal'
    });
    DialogRefRecover.componentInstance.OpenOnboardingModalEvent.subscribe((res: any) => {
      this.OpenOnboardingModal(res);
    });
  }

  OpenRegisterModal(typeUser: string){
    let DialogRefRegister = this.dialogLogin.open(CcRegisterComponent , {
      data:  {'isModal': true , 'typeUser': typeUser},
      panelClass: 'onboardingModal'
    });
    DialogRefRegister.componentInstance.OpenOnboardingModalEvent.subscribe((res: any) => {
      this.OpenOnboardingModal(res);
    });
  }
}
